import { DEFAULT_PANEL_MODE } from "@/components/mosaic/mosaicMenu/MosaicMenuItems";
import {
	ChartTypes,
	Subcharts,
	Timeframes,
} from "@/components/widgets/Chart/types";
import { DEFAULT_TICKER } from "@/shared/constants/common";
import type { TabsState } from "./types";

export const predefinedTabValues: TabsState = [
	{
		id: "Default-Markets",
		name: "Markets",
		layout: {
			direction: "row",
			first: "Markets",
			second: "Quote",
			splitPercentage: 75,
		},
		widgets: {
			Markets: {
				ticker: DEFAULT_TICKER,
				color: "var(--background)",
			},
			Quote: {
				ticker: DEFAULT_TICKER,
				color: "var(--background)",
			},
		},
		isDefault: true,
	},
	{
		id: "Default-Monitor",
		name: "Monitor",
		layout: {
			direction: "row",
			first: {
				direction: "row",
				first: "Monitor",
				second: "Chart",
				splitPercentage: 33,
			},
			second: "Quote",
			splitPercentage: 75,
		},
		widgets: {
			Chart: {
				ticker: DEFAULT_TICKER,
				timeFrame: Timeframes.ONE_DAY,
				color: "var(--background)",
				type: ChartTypes.ADVANCED,
				panels: [Subcharts.TimingMomentum],
			},
			Monitor: {
				ticker: "",
				color: "var(--background)",
				isOneClickTrigger: true,
				panelMode: DEFAULT_PANEL_MODE,
			},
			Quote: {
				ticker: DEFAULT_TICKER,
				color: "var(--background)",
			},
		},
		isDefault: true,
	},
	{
		id: "Default-Screener",
		name: "Screener",
		layout: {
			direction: "row",
			first: "Screener",
			second: "Quote",
			splitPercentage: 75,
		},
		widgets: {
			Quote: {
				ticker: DEFAULT_TICKER,
				color: "var(--background)",
			},
			Screener: {
				ticker: "",
				color: "var(--background)",
				isOneClickTrigger: true,
				panelMode: DEFAULT_PANEL_MODE,
			},
		},
		isDefault: true,
	},
];

export const DEFAULT_TAB_NUMBER = predefinedTabValues.length;

export const defaultScreenerAndMonitorState = {
	ticker: "",
	color: "var(--background)",
	isOneClickTrigger: true,
	panelMode: DEFAULT_PANEL_MODE,
};
